module.exports = __webpack_public_path__ + "static/media/disappointed-face.d7f7f78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/disappointed-face.png
// module id = 773
// module chunks = 1